import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { rootRoute } from 'root/RootLayout';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'login',
  component: lazyRouteComponent(() => import('./LoginView')),
  validateSearch: z.object({
    token: z.string().optional(),
    code: z.string().optional(),
  }).parse,
});
